import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import {NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

const OrganismeCoordonnees = (props) =>
{
    const [emailContact, setEmailContact] = useState('');
    const [telephone, setTelephone] = useState('');

    const green = '#59B44A';
    const purple = '#6571FE';

    function formatPhone(raw) {
        // Garde uniquement chiffres et un + en début
        const cleaned = raw.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');

        if (cleaned.startsWith('+33')) {
            const rest = cleaned.slice(3).slice(0, 9);
            if (!rest) return '+33';
            const pairs = rest.slice(1).match(/.{1,2}/g) || [];
            return '+33' + rest[0] + (pairs.length ? ' ' + pairs.join(' ') : '');
        }

        if (cleaned.startsWith('0')) {
            const limited = cleaned.slice(0, 10);
            return limited.match(/.{1,2}/g)?.join(' ') || limited;
        }

        return raw;
    }

    function isValidPhone(val) {
        const local = /^0\d( \d{2}){4}$/;
        const intl = /^\+33\d( \d{2}){4}$/;
        return local.test(val) || intl.test(val);
    }

    async function mount()
    {
        if (props.user && props.user.id_organisme)
        {
            await axios.post('/api/organismes.php', qs.stringify({
                'getOrganismes': true,
                'id': props.user.id_organisme
            }))
            .then((res) => {
                if (res && res.data && res.data[0]) {
                    setEmailContact(res.data[0].email_contact || '');
                    setTelephone(res.data[0].telephone || '');
                }
            })
            .catch((err) => {
                console.warn(err);
            });
        }
    }

    useEffect(() => {
        mount();
    }, [props.user]);

    const updateCoordonnees = async () => {
        if (telephone && !isValidPhone(telephone)) {
            NotificationManager.error('Format invalide. Utilisez 01 23 45 67 89 ou +33 1 23 45 67 89', '', 4000);
            return;
        }
        try {
            const params = {
                'updateOrganisme': true,
                'id': props.user.id_organisme,
                'email_contact': emailContact,
                'telephone': telephone
            };
            const res = await axios.post('/api/organismes.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success('Coordonnées mises à jour avec succès.', '', 2000);
            } else {
                const msg = res && res.data && res.data.status_message ? res.data.status_message : 'Erreur mise à jour coordonnées';
                NotificationManager.error(msg, '', 4000);
            }
        } catch (e) {
            NotificationManager.error('Erreur lors de la requête de mise à jour.', '', 4000);
            console.error(e);
        }
    };

    return (
        <div className='shadow-md' style={{textAlign: 'left', borderRadius: 3, padding: 20, margin: 1, backgroundColor: 'white'}}>
            <div style={{textAlign: 'center'}}>
                <p style={{fontWeight: 'bold', fontSize: 16, marginBottom: 20, color: purple}}>Coordonnées de contact</p>
            </div>

            <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Email de contact</label>
                    <input
                        type='email'
                        value={emailContact}
                        onChange={(e) => setEmailContact(e.target.value)}
                        style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}}
                        placeholder='contact@organisme.fr'
                    />
                </div>

                <div style={{flex: '1 1 45%'}}>
                    <label style={{display: 'block', marginBottom: 6, fontWeight: 600}}>Téléphone</label>
                    <input
                        type='tel'
                        value={telephone}
                        onChange={(e) => setTelephone(formatPhone(e.target.value))}
                        style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}}
                        placeholder='Ex : 01 23 45 67 89 ou +33 1 23 45 67 89'
                    />
                </div>
            </div>

            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 20}}>
                <button
                    onClick={updateCoordonnees}
                    style={{padding: '8px 12px', borderRadius: 4, backgroundColor: green, color: 'white', border: 'none', cursor: 'pointer'}}
                >
                    Mettre à jour
                </button>
            </div>
        </div>
    );
}

export default OrganismeCoordonnees;
